import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NewLeadInput } from '../../../../shared/models/lead/newLead.input';
import { EventService } from '../../../../shared/services/event/event.service';
import { LeadService } from '../../../../shared/services/lead/lead.service';
import { AuthService } from '../../../../shared/services/security/auth.service';
import { StylesProvider } from '../../../../shared/services/utils/styles.provider';
import { ToastService } from '../../../../shared/services/utils/toast.service';
import { TranslatorService } from '../../../../shared/services/utils/translator.service';
import { LeadsComunicationService } from '../../../leads/leads-comunication.service';
import { ModalsHandlerService } from '../../../modals/modals.handler.service';
import { TemplateLeadFormComponent } from '../template-lead-form-component';

@Component({
  selector: 'ngx-new-lead-modal',
  templateUrl: '../template-lead-form.html'
})
export class NewLeadFormComponent extends TemplateLeadFormComponent implements OnInit, AfterViewInit {

  // Default Channel "DMSVO"
  defaultChannelId = '6c7ab193-9687-11e9-9974-0242ac120002';
  defaultChannelName = 'DMSVO';

  newLeadInput: NewLeadInput = new NewLeadInput();
  newModal: boolean;
  editModal: boolean;

  @ViewChild('dropDownChannel', { static: false }) channel: TemplateRef<any>;

  constructor(
    protected leadComunicationService: LeadsComunicationService,
    protected modalsHandler: ModalsHandlerService,
    protected modalService: NgbModal,
    protected toasterService: ToastService,
    protected styleProvider: StylesProvider,
    protected formBuilder: FormBuilder,
    protected readonly leadService: LeadService,
    protected eventService: EventService,
    private readonly authService: AuthService,
    private readonly translatorService: TranslatorService,
  ) {
    super(
      leadComunicationService,
      leadService,
      modalsHandler,
      modalService,
      toasterService,
      formBuilder,
      styleProvider,
      eventService
  );
    this.modalEmitter = this.modalsHandler.newLeadModal;
    this.newModal = true;
    this.editModal = false;
    this.channelSelected = { id: this.defaultChannelId, name: this.defaultChannelName };

    this.zipCode = '';
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.authService.hasDropdownRulesTheUserRole()) {
        this.channelSelected = { id: 'no-id', name: this.translatorService.trans('dropdown.unknown') };
      }
    });
  }

  ngOnInit() {
    super.ngOnInit();

    this.eventService.subscribe('resetNewLeadForm', () => {
      this.channelSelected = { id: 'no-id', name: this.translatorService.trans('dropdown.unknown') };
    });

    this.canSubmitOrigin();
  }

  launchQuery(): void {
    this.newLeadInput.lead = this.lead;
    const toasterSuccess = { title: 'toaster.new.lead.success', body: 'toaster.new.lead.success.body' };
    const toasterError = { title: 'toaster.new.lead.error', body: 'toaster.new.lead.error.body' };
    this.subscribeMe(this.leadService.newLead$(this.newLeadInput), toasterSuccess, toasterError);
    this.zipCode = '';
  }

  getLead(): void {
    return;
  }

  closeModal() {
    this.modalService.dismissAll();
  }

}
